import { FormControl } from '@angular/forms';

export function checkboxValidator(control: FormControl): { [invalidCheckbox: string]: boolean } {
  if (control.value.filter(el => el).length === 0) {
    return { invalidCheckbox: true };
  }

  return null;
}
